import React from 'react';
import { Users, TrendingUp, Award } from 'lucide-react';
import '../CSS/Portfolio.css';

const Portfolio = () => {
  const projects = [
    {
      title: 'Steora AI Transformation',
      company: 'Steora',
      description:
        'Led comprehensive AI training program for employees and built custom AI agents that automated key business processes, resulting in 40% efficiency improvement.',
      tags: ['AI Training', 'Custom Agents', 'Process Automation'],
      icon: Users,
    },
    {
      title: 'E-commerce AI Assistant',
      company: 'Confidential Client',
      description:
        'Developed an intelligent customer service AI agent that handles 80% of customer inquiries automatically, improving response times and customer satisfaction.',
      tags: ['Customer Service', 'AI Agent', 'E-commerce'],
      icon: TrendingUp,
    },
    {
      title: 'Content Automation Platform',
      company: 'Coming Soon',
      description:
        'Building a comprehensive platform that automates content creation workflows for digital marketers and content creators.',
      tags: ['Content Creation', 'Automation', 'SaaS'],
      icon: Award,
    },
  ];

  return (
    <section id="portfolio" className="portfolio-section">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <h2 className="portfolio-title">Past Work</h2>
          <div className="gradient-divider portfolio-divider"></div>
        </div>

        <div className="portfolio-grid">
          {projects.map((project, idx) => {
            const IconComponent = project.icon;
            return (
              <div
                key={project.title}
                className="portfolio-card"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                <div className="portfolio-header-row">
                  <div className="portfolio-icon-container">
                    <IconComponent size={20} className="portfolio-icon" />
                  </div>
                  <div className="portfolio-title-group">
                    <h3 className="project-title">{project.title}</h3>
                    <p className="project-company">{project.company}</p>
                  </div>
                </div>

                <p className="project-desc">{project.description}</p>

                <div className="project-tags">
                  {project.tags.map((tag) => (
                    <span key={tag} className="project-tag">
                      {tag}
                    </span>
                  ))}
                </div>

                {/* <button className="project-cta">View Case Study</button> */}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
